import styled from '@emotion/styled';

export const TestSettingLayout = styled.div`
  width: 100vw;
  height: 100vh;
  min-width: 1280px;
  min-height: 590px;
  background-size: 100% 100%;
  background: #2c2c2c;
  @media screen and (min-width: 1440px) {
    min-height: 678px;
  }
  @media screen and (min-width: 1920px) {
    min-height: 836px;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 768px;
  background-image: url('/img/background.png');
  background-size: cover;
`;
